import { makeObservable, override } from 'mobx';
import Filter from './filter';
import filter from './filter';

class SpecialistFilter extends Filter {
    constructor(model) {
        super(model);

        makeObservable(this, {
            // inherited
            filtered: override,
            setFilter: override
        })
    }

    setFilter(key, value) {
        if (this.filters[key] === undefined) {
            console.warn(`unknown filter key: ${key}`);
        }
        if (value === null) {
            this.filters[key] = null;
        } else {
            this.filters[key] = value;
        }
    }

    applyFilters(filters) {
        const predicate = (a, b) => ( a === b || a === b.id || a === b[0] )
        const keys = Object.keys(filters);
        const filteredSpecialists = this.name ?
            this.specialists.filter(spec => spec.data.name === this.name) :
            this.specialists;
        return filteredSpecialists.filter((spec) => {
            return keys.every(key => {
                if (!filters[key]) return true;
                const specProp = spec[key] instanceof Map ? Array.from(spec[key]) : spec[key];
                if (Array.isArray(specProp)) {
                    return specProp.some(specProp => {
                        return predicate(filters[key], specProp);
                    });
                }
                return predicate(filters[key], spec[key]);
            });
        });
    }

    get filtered() {
        return this.applyFilters(this.filters);
    }

}

export default SpecialistFilter;
